import { useEffect, useState } from "react";
import { FaArrowDown, FaArrowUp } from "react-icons/fa6";
import Dropdown from "./dropdown";
import { SortDropdownProps } from "./types";

const SortDropdown = ({ label, onChange, initialSortOrder }: { label: string; onChange: (value: string) => void; initialSortOrder?: string }) => {
  const options: SortDropdownProps = {
    desc: {
      label: "Newest - Oldest",
      icon: <FaArrowDown />, // ReactNode type allows JSX elements
      abbreviation: "Sort: Newest First",
    },
    asc: {
      label: "Oldest - Newest",
      icon: <FaArrowUp />, // ReactNode type allows JSX elements
      abbreviation: "Sort: Oldest First",
    },
  };

  const [selected, setSelected] = useState(initialSortOrder);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setSelected(initialSortOrder);
  }, [initialSortOrder]);

  const handleChange = (sortOrder: string) => {
    setSelected(sortOrder);
    onChange(sortOrder);
    setIsOpen(false);
  };

  return (
    <Dropdown
      label={selected && options[selected] ? options[selected].abbreviation : label}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className="w-44 z-10"
    >
      <div>
        {Object.entries(options).map(([value, option]) => (
          <div key={value}>
            <button
              type="button"
              onClick={() => handleChange(value)}
              className="flex min-w-44 items-center justify-between px-4 py-2 text-left text-sm leading-5"
            >
              {option.label}
              {option.icon}
            </button>
          </div>
        ))}
      </div>
    </Dropdown>
  );
};

export default SortDropdown;
